<template>
  <div id="signin">
    <div class="signin__container">
      <header>
        <div class="row m-0">
          <div class="col-lg-6 signin__container--left">
            <a href="https://andalin.com/">
              <img src="@/assets/image/logo-andalin-putih.png" alt="" />
            </a>
          </div>
          <div class="col-lg-6 signin__container--right">
            <div class="d-flex justify-content-end">
              <router-link :to="{ name: 'RegisterCustomer' }" tag="a">
                Sign Up
              </router-link>
              <a href="https://andalin.com/">Back to Andalin.com</a>
            </div>
          </div>
        </div>
      </header>

      <div class="customform">
        <form @submit.prevent="handleSubmit">
          <div class="customform__tittle">
            <h3 class="m-0">Welcome to Andalin</h3>
          </div>
          <p class="mb-2">Email Address</p>
          <div class="form-group">
            <b-form-input
              v-model="user.username"
              v-validate="'required'"
              class="pl-1"
              type="text"
              name="username"
              placeholder="Enter Registered Email Address"
              autofocus
            ></b-form-input>
            <div class="fontstyle__errormsg">
              {{ errors.first("username") }}
            </div>
          </div>

          <p class="mb-2">Enter Password</p>
          <div class="form-group passwordvalue">
            <b-form-input
              v-model="user.password"
              v-bind:type="fieldType1"
              v-validate="'required'"
              name="password"
              autocomplete="new-password"
              class="pl-1"
              placeholder="Password"
            ></b-form-input>
            <div class="toggle-password" @click="toggleType1">
              <img
                class="passwordvalue__eyesabsolute"
                src="@/assets/image/icon/icon-eye-slash.png"
                v-if="fieldType1 == 'password'"
              />
              <img
                class="passwordvalue__eyesabsolute open"
                src="@/assets/image/icon/icon-eye.png"
                v-if="fieldType1 == 'text'"
              />
            </div>
            <div class="fontstyle__errormsg">
              {{ errors.first("password") }}
            </div>
          </div>
          <div class="pb-2 text-center">
            <div v-if="error" class="fontstyle__errormsg">
              {{ error.message }}
            </div>
          </div>
          <div class="pt-3 text-center">
            <button
              type="submit"
              class="button__redcorporite"
              v-bind:class="{ active: isActive }"
              :disabled="!isActive"
            >
              <span v-if="!isLoading">
                <b>Sign In</b>
              </span>
              <span v-else>
                <b-spinner small variant="light" label="Spinning" />
              </span>
            </button>
          </div>
          <router-link :to="{ name: 'ForgotPassword' }">
            <a
              href="#"
              class="fontstyle__link--white mt-2 d-flex justify-content-center"
              >Forgot password?</a
            >
          </router-link>
          <div class="d-flex justify-content-center text-center">
            <p class="my-2 footertext ">By registering you confirm that you accept the <br>
            <a @click.prevent="terms()" href="#">Terms &amp; Conditions</a> and
            <a @click.prevent="policy()" href="#">Privacy Policy</a>
          </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { VueRecaptcha } from 'vue-recaptcha'
export default {
  name: 'signIn',
  components: { VueRecaptcha },
  data () {
    return {
      user: {
        username: '',
        password: ''
      },
      fieldType1: 'password',
      isActive: false
    }
  },
  computed: {
    ...mapGetters({
      isAuth: 'auth/isAuth',
      auth: 'auth/items',
      error: 'auth/error',
      isLoading: 'auth/isLoading'
    })
  },
  watch: {
    'user.username' (data) {
      if (data) {
        this.chkInput()
      }
    },
    'user.password' (data) {
      if (data) {
        this.chkInput()
      }
    }
  },
  mounted () {
    if (this.isAuth) {
      this.$router.push('/dashboard').then(() => {})
    }
    if (this.$route.query.mail) {
      this.user.username = this.$route.query.mail
    }
  },
  methods: {
    chkInput () {
      if (this.user.username && this.user.password) {
        this.isActive = true
      } else {
        this.isActive = false
      }
    },
    toggleType1: function () {
      if (this.fieldType1 === 'password') {
        this.fieldType1 = 'text'
      } else {
        this.fieldType1 = 'password'
      }
    },
    handleSubmit (e) {
      this.user.token = this.token
      this.$validator.validateAll().then(result => {
        if (result) {
          return this.$store.dispatch('auth/POST_LOGIN', this.user)
        }
        alert('Correct them errors!')
      })
    },
    terms: function () {
      this.$eventHub.$emit('dialog-rule-terms')
    },
    policy: function () {
      this.$eventHub.$emit('dialog-rule-policy')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/signin/index.vue